import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const styles = () => ({
    list: {
        maxWidth: 400,
    },
    empty: {
        fontStyle: 'italic',
    },
});

class FieldList extends React.Component {
    render() {
        return (
            <List className={this.props.classes.list}>
                <ListItem>
                    <ListItemText primary="None" classes={{ primary: this.props.classes.empty }} />
                </ListItem>
            </List>
        );
    }
}

export default withStyles(styles)(FieldList);
